import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import AdminHeader from '../components/AdminHeader';
import InstanceManager from '../components/InstanceManager';
import { useAuth } from '../components/AuthGate';
import useAdminInstance from '../hooks/useAdminInstance';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a2e 100%);
`;

const Content = styled.div`
  padding: 24px;
`;

/**
 * InstanceManagerScreen - Instanssien hallinta: every Kuutio instance, and
 * one way into each (its Yleiskuva). Server-wide; an instance's own settings
 * live on its Valmistelu pages (specs/admin-instance-lifecycle.md).
 *
 * Route: /admin/instances
 */
const InstanceManagerScreen = () => {
  const navigate = useNavigate();
  // Server page: don't write the remembered instance back into the URL.
  const { selectInstance } = useAdminInstance({ restoreFromStorage: false });
  const { isAdmin } = useAuth();

  const handleSelectInstance = (instance) => {
    selectInstance(instance.id);
    navigate(`/admin?instance=${instance.id}`);
  };

  // A new Kuutio starts on its Perustiedot, with Valmistelu ahead of it.
  const handleCreateInstance = (instance) => {
    selectInstance(instance.id);
    navigate(`/admin/settings?instance=${instance.id}`);
  };

  if (!isAdmin) {
    return null;
  }

  return (
    <Container>
      <AdminHeader />
      <Content>
        <InstanceManager onSelectInstance={handleSelectInstance} onCreateInstance={handleCreateInstance} />
      </Content>
    </Container>
  );
};

export default InstanceManagerScreen;
